module.exports = "/_next/static/images/9087b6c1b786b61356351c920c927876-woman-holding-card-smiling-2@tablet768.png.webp";